import log from "cslog";
import React, { useEffect, useState } from "react";
import {
    decodeStyle,
    isHidden,
    mobile,
    parseStyle,
    tablet,
} from "../../../../juntion";
import Element from "../../ElementStaticView";

function TabButton({ tab, input, onClick, isSlected, style, styleSelected }) {
    return (
        <button
            // onClick={onClick}
            onMouseDown={onClick}
            style={{
                textAlign: input.textAlign,
                //fix style
                outline: "none",
                boxSizing: "border-box",
                backgroundSize: "contain",
                ...style,
                ...(isSlected && styleSelected),
                cursor: "pointer",
                transition: 0,
            }}
        >
            {tab.name}
        </button>
    );
}

function Tabs({ id, db, device, gs, dydb, ctx }) {
    const data = db[id];
    const [selectedTab, setSelectedTab] = useState(null);

    //=========================
    const ps = parseStyle(data, gs, data.cstate);

    // log.d(data, "Tabs Data");

    const tabButtonStyle = decodeStyle(ps.styleGroup.tabButton, gs);
    const tabButtonSelectedStyle = decodeStyle(
        ps.styleGroup?.tabButton__selected || {},
        gs
    );

    // const tabletStyle = tablet(device) ? ps.tablet : {};
    // const mobileStyle = mobile(device) ? ps.mobile : {};

    let input = ps.input;
    input = { ...input, ...(tablet(device) && ps.itablet) };
    input = { ...input, ...(mobile(device) && ps.imobile) };

    useEffect(() => {
        if (!selectedTab) {
            setSelectedTab(input.selectedTab);
        }
    }, [input]);

    if (isHidden(ps.classes, device)) {
        return null;
    }

    const selectTab = (tab_id) => {
        setSelectedTab(tab_id);
    };

    const optionsMode = input.optionsMode; // tabs, dropdown

    return (
        <div>
            <div
                style={{
                    display: "flex",
                    flexDirection: `${
                        input.orientation === "h" ? "column" : "row"
                    }${input.flipSide ? "-reverse" : ""}`,
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection:
                            input.orientation === "h" ? "row" : "column",
                        justifyContent:
                            input.orientation === "h"
                                ? input.alignItems
                                : "stretch",
                        // alignItems: input.alignItems,
                    }}
                >
                    {optionsMode === "tabs" &&
                        input.tabs.map((tab) => {
                            return (
                                <TabButton
                                    key={tab.id}
                                    tab={tab}
                                    input={input}
                                    onClick={() => {
                                        selectTab(tab.id);
                                    }}
                                    isSlected={tab.id === selectedTab}
                                    style={tabButtonStyle}
                                    styleSelected={tabButtonSelectedStyle}
                                />
                            );
                        })}
                    {optionsMode === "dropdown" && (
                        <div
                            style={{
                                maxWidth: "100%",
                            }}
                        >
                            <select
                                style={{
                                    ...tabButtonStyle,
                                    outline: "none",
                                    paddingRight: "50px",
                                    textWrap: "wrap",
                                    maxWidth: "100%",
                                }}
                                value={selectedTab || input.selectedTab}
                                onChange={(e) => {
                                    selectTab(e.target.value);
                                }}
                            >
                                {input.tabs.map((tab) => (
                                    <option key={tab.id} value={tab.id}>
                                        {tab.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}
                </div>
                {/* <p>{JSON.stringify(data.childs)}</p> */}
                <div
                    style={{
                        flex: 1,
                        // border: "1px dashed purple",
                    }}
                >
                    {input.selectedTab && (
                        <Element
                            key={selectedTab || input.selectedTab}
                            id={selectedTab || input.selectedTab}
                            index={0}
                            db={db}
                            dydb={dydb}
                            gs={gs}
                            device={device}
                            ctx={ctx}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}

export default Tabs;
